export default {
    // СУНДУКИ
    chest_gray_1: {
        grade: 1, type: 'chest', src: `/../images/ver2/scores/chest/chest_gray_1.png`,
        title: 'Серый сундук сокровищ',
        discription: 'Небольшой базовый сундук сокровищ',
    },
    chest_gray_2: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_gray_2.png`,
        title: 'Серый сундук сокровищ',
        discription: 'Небольшой продвинутый сундук сокровищ',
    },
    africa_white: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/africa_white.png`,
        title: 'Африка: белый сундук',
        discription: 'Сундук, из которго выпадают сувениры всех наборов',
    },
    chest_africa_white: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_africa_white.png`,
        title: 'Африка: белый сундук',
        discription: 'Сундук, из которго выпадают сувениры всех наборов',
    },
    chest_africa_red: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_africa_red.png`,
        title: 'Африка: красный сундук',
        discription: 'Сундук, из которго выпадают сувениры красного набора',
    },
    chest_africa_black: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_africa_black.png`,
        title: 'Африка: черный сундук',
        discription: 'Сундук, из которго выпадают сувениры черного набора',
    },

    chest_cip2026_200: {
        grade: 2, type: 'chest', src: `/../images/ver2/scores/chest/chest_cip2026_200.png`,
        title: 'ЧР 2026 простой сундук',
        discription: 'Сундук, из которго выпадают флаги или обложки',
    },

    chest_cip2026_1000: {
        grade: 4, type: 'chest', src: `/../images/ver2/scores/chest/chest_cip2026_1000.png`,
        title: 'ЧР 2026 ПРО сундук',
        discription: 'Сундук, из которго выпадают флаги или обложки и акула',
    },

    chest_cip2026_5000: {
        grade: 5, type: 'chest', src: `/../images/ver2/scores/chest/chest_cip2026_5000.png`,
        title: 'ЧР 2026 простой сундук',
        discription: 'Сундук, из которго выпадают флаги или обложки, акула и купон на футболку',
    },

}
/*
const A = {
    "chest_cip2026_200": [
        {
            percent: 100,
            entrys: [
                {
                    percFrom: 0, percTo: 100,
                    money: [
                        { label: 'squ', from: 1, to: 3 },
                    ]
                }
            ]
        },
        {
            percent: 100,
            entrys: [
                { percFrom: 0, percTo: 16, item: { 'cover_cip2025_3': {} } },
                { percFrom: 17, percTo: 33, item: { 'cover_cip2026b_3': {} } },
                { percFrom: 34, percTo: 50, item: { 'cover_cip2026g_3': {} } },
                { percFrom: 51, percTo: 67, item: { 'flagl_cip2026r': {} } },
                { percFrom: 68, percTo: 84, item: { 'flagl_cip2026b': {} } },
                { percFrom: 85, percTo: 100, item: { 'flagl_cip2026g': {} } }
            ]
        }
    ],
    "chest_cip2026_1000": [
        {
            percent: 100,
            entrys: [
                {
                    percFrom: 0, percTo: 100,
                    money: [
                        { label: 'squ', from: 1, to: 3 },
                    ]
                }
            ]
        },
        {
            percent: 100,
            entrys: [
                { percFrom: 0, percTo: 16, item: { 'cover_cip2025_3': {} } },
                { percFrom: 17, percTo: 33, item: { 'cover_cip2026b_3': {} } },
                { percFrom: 34, percTo: 50, item: { 'cover_cip2026g_3': {} } },
                { percFrom: 51, percTo: 67, item: { 'flagl_cip2026r': {} } },
                { percFrom: 68, percTo: 84, item: { 'flagl_cip2026b': {} } },
                { percFrom: 85, percTo: 100, item: { 'flagl_cip2026g': {} } }
            ]
        },
        {
            percent: 100,
            entrys: [
                { percFrom: 0, percTo: 33, item: { 'shark_cip_a': {} } },
                { percFrom: 34, percTo: 66, item: { 'shark_cip_p': {} } },
                { percFrom: 67, percTo: 100, item: { 'shark_cip_b': {} } }
            ]
        }
    ],
    "chest_cip2026_5000": [
        {
            percent: 100,
            entrys: [
                {
                    percFrom: 0, percTo: 100,
                    money: [
                        { label: 'squ', from: 1, to: 3 },
                    ]
                }
            ]
        },
        {
            percent: 100,
            entrys: [
                { percFrom: 0, percTo: 16, item: { 'cover_cip2025_3': {} } },
                { percFrom: 17, percTo: 33, item: { 'cover_cip2026b_3': {} } },
                { percFrom: 34, percTo: 50, item: { 'cover_cip2026g_3': {} } },
                { percFrom: 51, percTo: 67, item: { 'flagl_cip2026r': {} } },
                { percFrom: 68, percTo: 84, item: { 'flagl_cip2026b': {} } },
                { percFrom: 85, percTo: 100, item: { 'flagl_cip2026g': {} } }
            ]
        },
        {
            percent: 100,
            entrys: [
                { percFrom: 0, percTo: 33, item: { 'shark_cip_a': {} } },
                { percFrom: 34, percTo: 66, item: { 'shark_cip_p': {} } },
                { percFrom: 67, percTo: 100, item: { 'shark_cip_b': {} } }
            ]
        },
        {
            percent: 100,
            entrys: [
                { percFrom: 0, percTo: 100, item: { 'futb_cip2026': {} } }
            ]
        }
    ]
}
*/